import {
  AGENT_TOOLS_REQUEST,
  AGENT_TOOLS_SUCCESS,
  AGENT_TOOLS_FAILURE,
  GET_AGENT_TOOLS_REQUEST,
  GET_AGENT_TOOLS_SUCCESS,
  GET_AGENT_TOOLS_FAILURE,
  UPDATE_AGENT_TOOLS_REQUEST,
  UPDATE_AGENT_TOOLS_SUCCESS,
  UPDATE_AGENT_TOOLS_FAILURE
} from '../actions/agentToolsActions';

const initialState = {
  // Tool list state
  toolList: [],
  toolListLoading: false,
  toolListError: null,
  
  // Agent tools state
  agentTools: [],
  agentToolsLoading: false,
  agentToolsError: null,
  
  // Update agent tools state
  updateLoading: false,
  updateError: null,
  updateSuccess: false
};

const agentToolsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Tool List Cases
    case AGENT_TOOLS_REQUEST:
      return {
        ...state,
        toolListLoading: true,
        toolListError: null
      };
    
    case AGENT_TOOLS_SUCCESS:
      return {
        ...state,
        toolListLoading: false,
        toolList: action.payload?.data?.tools || action.payload || [],
        toolListError: null
      };
    
    case AGENT_TOOLS_FAILURE:
      return {
        ...state,
        toolListLoading: false,
        toolListError: action.payload
      };

    // Get Agent Tools Cases
    case GET_AGENT_TOOLS_REQUEST:
      return {
        ...state,
        agentToolsLoading: true,
        agentToolsError: null
      };
    
    case GET_AGENT_TOOLS_SUCCESS:
      return {
        ...state,
        agentToolsLoading: false,
        agentTools: action.payload?.data?.tools || action.payload || [],
        agentToolsError: null
      };
    
    case GET_AGENT_TOOLS_FAILURE:
      return {
        ...state,
        agentToolsLoading: false,
        agentToolsError: action.payload
      };

    // Update Agent Tools Cases
    case UPDATE_AGENT_TOOLS_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateError: null,
        updateSuccess: false
      };
    
    case UPDATE_AGENT_TOOLS_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updateSuccess: true,
        updateError: null
      };
    
    case UPDATE_AGENT_TOOLS_FAILURE:
      return {
        ...state,
        updateLoading: false,
        updateError: action.payload,
        updateSuccess: false
      };

    default:
      return state;
  }
};

export default agentToolsReducer;
